<template>
  <Map
    ref="componentMapRef"
    v-bind="configMapRef"
  >
  </Map>
</template>

<script setup>
import {onBeforeMount, ref} from 'vue';
import {useStore} from 'vuex';
import {useImmer} from '@sttedra_ui/framework';
import Map from '@/components/map/Map';
import {getMapBases} from '@/api/visor/mapBase/mapBase.api';
import {getLayersForVisor} from '@/api/visor/layer/layer.api';
import {getCoordinatesSystem} from '@/api/visor/coordinateSystem/coordinateSystem.api';
import configMap from './config.map';

// #region Props, Emits
const props___ = defineProps({
  configMap: {
    type: Object,
    default: null,
  },
});
// #endregion


// #region Params, Ref, Reactives, Computed
const store = useStore();
const {
  ref: configMapRef,
  update: updateConfigMapRef,
} = useImmer(configMap);
const componentMapRef = ref();

// #endregion


// #region Functions
async function getInitialRequest() {
  const requests = [
    await getMapBases(),
    await getLayersForVisor(),
    await getCoordinatesSystem(),
  ];
  const [mapBases, layers, coordinatesSystem] =
  await Promise.all(requests);
  return {
    mapBases,
    layers,
    coordinatesSystem,
  };
}

// TODO: Refactor with views/MapVector.vue
function prepareStructureLayer(layer) {
  let alternativeRequest = null;
  if (layer.alternativeRequest) {
    alternativeRequest = {
      url: layer.alternativeRequest?.protocol?.toLowerCase() === 'tms' ?
        layer.getUrlRequestAlternative() :
        layer.getUrlCapabilitiesAlternative(),
      layer: (
        layer.alternativeRequest?.workspace ? `${layer.alternativeRequest?.workspace}:` : ''
      ) + layer.alternativeRequest?.name,
      format: layer.alternativeRequest?.protocol,
      params: {
        FORMAT: layer.alternativeRequest?.imageFormat,
      },
      visible: false,
      values: layer,
      opacity: layer.opacity ? layer.opacity / 100 : 1,
      minZoom: layer.zoomMax - 1 ?? 0,
      maxZoom: 30,
      crossOrigin: layer.alternativeRequest?.crossOrigin,
    };
  }
  return {
    url: layer.request?.protocol?.toLowerCase() === 'tms' ?
      layer.getUrlRequest() :
      layer.getUrlCapabilities(),
    layer: (layer.request?.workspace ? `${layer.request?.workspace}:` : '') + layer.request?.name,
    format: layer.request?.protocol,
    params: {
      FORMAT: layer.request?.imageFormat,
    },
    visible: layer.default,
    values: layer,
    opacity: layer.opacity ? layer.opacity / 100 : 1,
    minZoom: layer.zoomMin ? layer.zoomMin - 1 : 0,
    maxZoom: layer.zoomMax ?? 20,
    crossOrigin: layer.request?.crossOrigin,
    legend: layer.getUrlLegend(),
    alternativeRequest,
  };
}
// #endregion

// #region Effects, Hooks
// onMounted(async () => {
onBeforeMount(async () => {
  const {mapBases, layers, coordinatesSystem} = await getInitialRequest();

  const baseMaps = [];
  const mapsMinimap = [];
  const overMaps = [];
  let layersGroup = [];

  mapBases.forEach((map) => {
    if (map.asLayer) {
      mapsMinimap.push(prepareStructureLayer(map));
    } else {
      baseMaps.push(prepareStructureLayer(map));
    }
  });

  const layersStructured = layers.map((layer) => {
    return prepareStructureLayer(layer);
  });

  layersGroup = layersStructured.filter((l) => l);

  updateConfigMapRef((draft) => {
    // const {lat, long} = props___.configMap.coordinatesBase;
    draft.zoom = props___.configMap.zoomBase;
    draft.maxSizePolygonRequest = props___.configMap.polygonAreaMax;
    draft.warningSizePolygonRequest = props___.configMap.polygonAreaWarning;
    draft.pdf = {
      width: props___.configMap.mapWidth4PDF,
      height: props___.configMap.mapHeight4PDF,
      zoom: props___.configMap.zoomOthers,
    };
    draft.minZoom = props___.configMap.zoomMin;
    draft.maxZoom = props___.configMap.zoomMax;
    // draft.center = [long, lat];
    draft.center = store.state.map.center;
    draft.maps = baseMaps;
    draft.overMaps = overMaps;
    draft.minimapMaps = mapsMinimap;
    draft.layersGroup = layersGroup;
    draft.coordinatesSystem = coordinatesSystem;
    return draft;
  });
});
// #endregion


// #region Provide, Expose
// #endregion
</script>


<style lang="scss" scoped>
// ...
</style>
